import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Compass } from 'lucide-react';

/** 404 propia (auditoría 9-oct): una dirección que no existe ya no se
 *  presenta como «incidente» — dice qué pasó y ofrece volver. */
export function NotFoundPage() {
  const { t } = useTranslation();
  return (
    <div className="grid min-h-[60dvh] place-items-center p-6">
      <div className="glass-strong w-full max-w-md rounded-3xl p-8 text-center">
        <div className="mx-auto mb-5 grid h-16 w-16 place-items-center rounded-2xl bg-primary/15 text-primary">
          <Compass className="h-8 w-8" aria-hidden="true" />
        </div>
        <p className="text-xs font-semibold uppercase tracking-widest text-muted-foreground">404</p>
        <h1 className="mt-1 font-display text-xl font-bold">{t('notFound.title')}</h1>
        <p className="mt-2 text-sm text-muted-foreground">{t('notFound.body')}</p>
        <Link to="/" className="focus-ring mt-6 inline-flex h-11 w-full items-center justify-center rounded-xl bg-brand-gradient px-5 text-sm font-medium text-white shadow-glow">
          {t('notFound.cta')}
        </Link>
      </div>
    </div>
  );
}
